import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { compose } from "redux";
import AliceCarousel from "react-alice-carousel";
import HeroBanner from "./component/HeroBanner";
import VectorMap from "./component/VectorMap";
import MasterService from "../services/MasterService";
import CategoryService from "../services/CategoryService";
import DashboardService from "../services/DashboardService";
import "../public/common.css";
import prodstat from "../public/prodstat.svg";
import docstat from "../public/docstat.svg";
import evnstat from "../public/evnstat.svg";
import arrow from "../public/arrow.svg";
import oppor from "../public/oppor.svg";
import { showLoading } from "react-global-loading";
import statleaf from "../public/statleaf.svg";

const Dashboard = ({ history }) => {
  const [selectedCategory, setSelectedCategory] = useState(1);
  const [selectedCountry, setSelectedCountry] = useState(0);
  const [categoriesStats, setCategoriesStats] = useState([]);
  const [countries, setCountries] = useState([]);
  const [searchedCountry, setSearchedCountries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [aboutAyush, setAboutAyush] = useState({});
  const [ayushChairs, setAyushChairs] = useState({});
  const [studentsOpp, setStudentsOpp] = useState({});

  const [dashboardData, setDashboardData] = useState();
  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
  };
  const [staticData, setStaticData] = useState([
    "Ayush Achievements",
    "User Guide",
    "Domain-wise statistics",
    "Practitioners",
    "Products",
    "Events",
    "Read More",
    "Country-wise Ayush Missions",
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllCountries();
    getAllCategories();
    getCatgoryStats();
    getDashboardData();
    // if ((localStorage.getItem('localLang') !== 'en')) {
    getAboutAyush();
    getAyushChairs();
    getStudentsOpp();
    // }

  }, []);

  const getStudentsOpp = () => {
    showLoading(true);

    DashboardService.getOpportunitiesForStudents()
      .then(result => {
        if (!result) {
          return;
        }

        setStudentsOpp(result.data);
        showLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  };

  const getAyushChairs = () => {
    showLoading(true);

    DashboardService.getAyushChairs()
      .then(result => {
        if (!result) {
          return;
        }

        setAyushChairs(result.data);
        showLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  };

  const getAboutAyush = () => {
    showLoading(true);

    DashboardService.getAyushGlobal()
      .then(result => {
        if (!result) {
          return;
        }
        setAboutAyush(result.data);
        showLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  };

  const getCatgoryStats = () => {
    CategoryService.getCategoryStats()
      .then(result => {
        if (!result) {
          return;
        }
        setCategoriesStats(result);
      })
      .catch(err => {
        console.error(err);
      });
  };

  const getTranslation = () => {
    MasterService.getTranslation({
      input: staticData,
    })
      .then(result => {
        if (!result) {
          return;
        }

        let translate = [];
        JSON.parse(result.data)?.output?.map((item, index) =>
          translate?.push(item.target),
        );
        // this.setState({ staticData: translate });
        setStaticData(translate);
      })
      .catch(err => {
        console.error(err);
      });
  };
  const getAllCategories = () => {
    MasterService.getCategories()
      .then(result => {
        if (!result) {
          return;
        }
        setCategories(result);
      })
      .catch(err => {
        console.error(err);
      });
  };

  // const getTranslation = () => {
  //   MasterService.getTranslation({ 'input': [] })
  //     .then(result => {
  //       if (!result) {
  //         return;
  //       }
  //       setCategories(result);
  //     })
  //     .catch(err => {
  //       console.error(err);
  //     });
  // }

  const getDashboardData = () => {
    showLoading(true);

    DashboardService.getDashboardData()
      .then(result => {
        if (!result) {
          return;
        }

        setDashboardData(result.data);
        showLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  };

  const getAllCountries = () => {
    MasterService.getAyushCountries()
      .then(result => {
        if (!result) {
          showLoading(false);
          return;
        }
        setCountries(result);
        setSearchedCountries(result);
        showLoading(false);
      })
      .catch(err => {
        console.error(err);
        showLoading(false);
      });
  };

  const findCountry = e => {
    const searchedCountry = countries.filter(item =>
      item.blogname.toLowerCase().includes(e.target.value),
    );
    setSearchedCountries(searchedCountry);
  };

  const focusOnRegion = country => {
    setSelectedCountry(country);
  };

  const onClickCountry = country => {
    history.push({
      pathname: "/country/" + country.blogname + "/" + country.id,
      countryCode: country,
    });
  };
  const middleSlider = dashboardData?.middleslider && dashboardData?.middleslider?.map((item, index) => (
    <div
      className="card rounded-0 position-relative overflow-hidden border-0 shadow"
      key={index}
    >
      <div className="card-body cbd_hm">
        <div className="carddesign"></div>
        <div className="pt-2">
          <span className="d-block mb-2">{item.post_date}</span>
          <h5 className="swcrt">{item?.post_title}</h5>
          <p className="crtxx crop-text">{item?.post_content} </p>
          <Link
            to="/"
            className="btn btn-outline-success  py-1 px-3 btn-sm rounded-5"
          >
            {item.tags[0]}
          </Link>
        </div>
      </div>
    </div>
  ));

  const bottomSlider = dashboardData?.bottomslider && dashboardData?.bottomslider?.map((item, index) => (
    <div className="crcard" key={index}>
      <img src={item.image} className="galimhm" alt="gallery" />
      <div className="galleryInfo">
        <span className="my-2 d-block">03-May-2022</span>
        <div className="d-flex justify-content-between">
          <Link to="/">{item?.post_title}</Link>
          <img src={arrow} alt="arrwo" />
        </div>
      </div>
    </div>
  ));

  return (
    <>
      {dashboardData?.topslider && (
        <HeroBanner data={dashboardData?.topslider} />
      )}

      {/* below is the first top carousel */}
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="swiper mySwiper">
                <AliceCarousel
                  animationType="slide"
                  autoPlayInterval={3000}
                  autoWidth={false}
                  autoPlay={true}
                  autoPlayStrategy="all"
                  controlsStrategy="responsive"
                  disableDotsControls
                  disableAutoPlayOnAction={true}
                  items={middleSlider}
                  responsive={responsive}
                  mouseTracking
                  touchTracking
                  infinite
                  mouseTrackingEnabled={true}
                  // autoHeight={true}
                  disableButtonsControls={false}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* below is the about ayush page            */}
      <div className="container pt-5" id="maincontent">
        <div className="abhdhm_ mb-3 mt-5">
          <p className="">{aboutAyush?.title?.rendered}</p>
          <div className="btmbrd"></div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <p className="abtdes">{aboutAyush?.content?.rendered}</p>
            <div className="abtncnt">
              <Link to="/" className="abbtns">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clip-rule="evenodd"
                    d="M19 8.99956C19.0007 10.1282 18.7283 11.2402 18.2058 12.2407C17.6834 13.2411 16.9266 14.1002 16 14.7446V21.9996H13.414L12 20.5856L10.586 21.9996H8V14.7446C7.01224 14.0568 6.21851 13.1259 5.69547 12.0419C5.17243 10.9578 4.93775 9.75722 5.0141 8.55601C5.09044 7.35481 5.47522 6.19358 6.13129 5.18447C6.78736 4.17536 7.69255 3.35247 8.75944 2.79527C9.82632 2.23806 11.0189 1.96537 12.2219 2.00352C13.4249 2.04167 14.5978 2.38938 15.6272 3.01307C16.6566 3.63676 17.5079 4.51535 18.0987 5.56401C18.6895 6.61266 18.9999 7.79593 19 8.99956ZM17 8.99956C17 10.3256 16.4732 11.5974 15.5355 12.5351C14.5979 13.4728 13.3261 13.9996 12 13.9996C10.6739 13.9996 9.40215 13.4728 8.46447 12.5351C7.52679 11.5974 7 10.3256 7 8.99956C7 7.67348 7.52679 6.40171 8.46447 5.46403C9.40215 4.52635 10.6739 3.99956 12 3.99956C13.3261 3.99956 14.5979 4.52635 15.5355 5.46403C16.4732 6.40171 17 7.67348 17 8.99956ZM10 19.7566L12 17.7566L14 19.7566V15.7096C13.3509 15.9024 12.6772 16.0001 12 15.9996C11.3228 16.0001 10.6491 15.9024 10 15.7096V19.7566Z"
                    fill="#009E6F"
                  />
                </svg>{" "}
                {staticData[0]}
              </Link>
              <Link to="/" className="abbtns">
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 15 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.68421 4.47368C2.68421 3.28719 3.15554 2.14929 3.99452 1.31031C4.8335 0.471333 5.9714 0 7.15789 0C8.34439 0 9.48229 0.471333 10.3213 1.31031C11.1602 2.14929 11.6316 3.28719 11.6316 4.47368C11.6316 5.66018 11.1602 6.79808 10.3213 7.63706C9.48229 8.47604 8.34439 8.94737 7.15789 8.94737C5.9714 8.94737 4.8335 8.47604 3.99452 7.63706C3.15554 6.79808 2.68421 5.66018 2.68421 4.47368ZM7.15789 7.15789C7.86979 7.15789 8.55253 6.87509 9.05592 6.37171C9.55931 5.86832 9.8421 5.18558 9.8421 4.47368C9.8421 3.76179 9.55931 3.07905 9.05592 2.57566C8.55253 2.07227 7.86979 1.78947 7.15789 1.78947C6.446 1.78947 5.76326 2.07227 5.25987 2.57566C4.75648 3.07905 4.47368 3.76179 4.47368 4.47368C4.47368 5.18558 4.75648 5.86832 5.25987 6.37171C5.76326 6.87509 6.446 7.15789 7.15789 7.15789ZM2.09637 11.9385C1.4317 12.6032 0.904473 13.3923 0.544777 14.2607C0.185081 15.1292 -3.42465e-05 16.06 4.75216e-09 17H1.78947C1.78947 15.5762 2.35507 14.2107 3.36185 13.204C4.36862 12.1972 5.7341 11.6316 7.15789 11.6316C8.58169 11.6316 9.94717 12.1972 10.9539 13.204C11.9607 14.2107 12.5263 15.5762 12.5263 17H14.3158C14.3158 15.5843 13.8961 14.2003 13.1095 13.0232C12.323 11.846 11.2051 10.9285 9.89714 10.3867C8.58917 9.84494 7.14992 9.70319 5.76139 9.9794C4.37286 10.2556 3.09742 10.9374 2.09637 11.9385Z"
                    fill="#009E6F"
                  />
                </svg>{" "}
                {staticData[1]}
              </Link>
            </div>
          </div>
          {/* <div className ="col-md-4"><img src={require('../public/about-img.png')} className ="img-fluid" alt="" /></div> */}
        </div>
      </div>

      {/* below is the domains statistics page */}
      <section id="ayushBranch" className=" aybh pt-5 ">
        {/* <div className="abhdhm_ mb-3 mt-5">
          <p className="">{staticData[2]}</p>
          <div className="btmbrd"></div>
        </div> */}
        <div className="container">
          <div className="d-flex justify-content-start align-items-start domscr">
            {categories.map((item, index) => (
              <div
                key={index}
                className={`branch justify-content-center flex-column ${selectedCategory === index ? "brhwr_hvr" : `brhwr`
                  }`}
              >
                <span
                  className="iconwrp"
                  onMouseEnter={() => setSelectedCategory(index)}
                >
                  <img
                    src={item.img_cat[0]}
                    className="img-fluid imbr_h"
                    alt="Ayurveda"
                  />
                </span>
                <span className="domnam">{item.cat_name}</span>
              </div>
            ))}
          </div>

          <div className="statbox">
            <div className="sbx">            
              <img src={docstat} className="statlogo" alt="Ayush Global Logo" />
              <p className="stxx">              
                <span className="numbl">
                  {categoriesStats[selectedCategory]?.practioner_count}
                </span>
                <br /> {staticData[3]}
              </p>
            </div>
            <div className="sbx">
              <img
                src={prodstat}
                className="statlogo"
                color="#009E6F"
                alt="Ayush Global Logo"
              />
              <p className="stxx">              
                <span className="numbl">
                  {categoriesStats[selectedCategory]?.product_count}
                </span>
                <br />
                {staticData[4]}
              </p>
            </div>
            <div className="sbx">
              <img src={evnstat} className="statlogo" alt="Ayush Global Logo" />
              <p className="stxx">
              
                <span className="numbl">
                  {categoriesStats[selectedCategory]?.event_count}
                </span>
                <br /> {staticData[5]}
              </p>
            </div>
            <img src={statleaf} className="leaficon" alt="stats leaf right" />
          </div>
        </div>
      </section>

      {/* below is the country wise ayush missions page */}
      <section className="pt-5 mver-cwam">
        <div className="container pb-5">
          <div className="abhdhm_ mb-3 mt-5">
            <p className="">{staticData[7]}</p>
            <div className="btmbrd"></div>
          </div>

          <div className="row mb-3">
            <div className="col-md-3 cntrymaplst">
              <form role="searchcountry">
                <input
                  aria-label="searchcountry"
                  style={{ borderRadius: "20px ", width: "100%" }}
                  type="text"
                  className="form-control"
                  id="portalsearch"
                  placeholder="Type here to search"
                  onKeyUp={e => findCountry(e)}
                />
              </form>
              <select
                name="orderby"
                className="cntrymaplst"
                size="15"
                aria-label="Shop order size=15"
                value={selectedCountry}
              >
                {searchedCountry?.map((item, index) => (
                  <option
                    className="cntoptn"
                    key={index}
                    value={item.blogname}
                    onMouseEnter={e => focusOnRegion(item)}
                    onClick={e => onClickCountry(item)}
                  >
                    {item.blogname}
                  </option>
                ))}
              </select>
            </div>
            <div className="col d-md-block d-none">
              <div id="map">
                {/* {selectedCountry ? */}
                <VectorMap highlightCountry={selectedCountry} />
                {/* : <VectorMap />} */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* below is the gallery section */}

      <section id="gllery" className="pt-5">
        <div>
          <div className="row">
            <div className="col">
              <div className="gallery gallbt">
                <AliceCarousel
                  animationType="slide"
                  autoPlayInterval={3000}
                  autoWidth={true}
                  autoPlay={true}
                  autoPlayStrategy="all"
                  controlsStrategy="responsive"
                  disableDotsControls
                  disableAutoPlayOnAction={true}
                  items={bottomSlider}
                  responsive={{
                    0: { items: 1 },
                    568: { items: 2 },
                    1920: { items: 3 },
                  }}
                  mouseTracking
                  touchTracking
                  infinite={true}
                  mouseTrackingEnabled={true}
                  // autoHeight={true}
                  disableButtonsControls={false}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* below is the opportunities section */}
      <section id="ayush-chair " className="pt-5">
        <div className="container">
          <div className="abhdhm_  mb-3 mt-5">
            <p className="">{studentsOpp?.title?.rendered}</p>
            <div className="btmbrd"></div>
          </div>
          <div className="row ">
            <div className="col-md-5">
              <img src={oppor} alt="" className="opima" />
            </div>
            <div className="col-md-7 ps-5 mver-ofs">
              <div className="ayushChair-info ">
                <p className=" lh-lg">
                  {studentsOpp?.content?.rendered}
                </p>
                <Link to="/opportunity-for-students" className="abbtns">
                  {staticData[6]}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* below is the ayush chair section */}
      <section className="py-5">
        <div className="container pb-5">
          <div className="abhdhm_ mb-3 mt-5">
            <p className="">{ayushChairs?.title?.rendered}</p>
            <div className="btmbrd"></div>
          </div>
          <div className="row aycsc">
            <div className="ayushChair-info">
              <p>{ayushChairs?.content?.rendered}</p>
            </div>
            <Link to="/ayush-chairs" className="abbtns">
              {staticData[6]}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};
const mapStateToProps = state => {
  return { translation: state.translation };
};

export default compose(connect(mapStateToProps, null), withRouter)(Dashboard);
